// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f0c938be","453":"7c6270d0","796":"c05e676e"}[chunkId] + ".chunk.js";
};